import { useAuthStore } from '@/auth/authStore';
import { SERVER_URL, COMMON_HEADERS } from '@/config/serverUrl';

export interface GameTip {
  id: string;
  text: string;
}

// Tips rarely change mid-session, so cache the first successful fetch for the
// lifetime of the tab. A failed fetch caches an empty list (the strip just
// hides) rather than retrying on every match.
let cache: GameTip[] | null = null;
let inflight: Promise<GameTip[]> | null = null;

export async function fetchTips(): Promise<GameTip[]> {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const token = useAuthStore.getState().token;
      const res = await fetch(`${SERVER_URL}/tips`, {
        headers: {
          ...COMMON_HEADERS,
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        credentials: 'include',
      });
      if (!res.ok) throw new Error(`tips ${res.status}`);
      const j = (await res.json()) as { tips: GameTip[] };
      cache = j.tips ?? [];
    } catch {
      cache = [];
    } finally {
      inflight = null;
    }
    return cache!;
  })();
  return inflight;
}
